import TLoginInvitedUserSms from './index.vue';

TLoginInvitedUserSms.install = app => {
  app.component(TLoginInvitedUserSms.name, TLoginInvitedUserSms);
};

export default TLoginInvitedUserSms;
